import { Typography } from '@mui/material';

import { ConfirmationDialog } from 'components/surfaces/dialogs/ConfirmationDialog';

type DiscardProposalDialogProps = {
  open: boolean;
  proposalName: string;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
  loading?: boolean;
  disabled?: boolean;
};

export const DiscardProposalDialog: React.FC<DiscardProposalDialogProps> = ({
  open,
  proposalName,
  onConfirm,
  onClose,
  loading = false,
  disabled = false
}) => (
  <ConfirmationDialog
    title='Discard proposal?'
    id='discard-proposal-dialog'
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    confirmButtonText='Discard proposal'
    cancelButtonText='Cancel'
    loading={loading}
    disabled={disabled}
  >
    <Typography>Discarding {proposalName} will permanently remove all its changes.</Typography>
  </ConfirmationDialog>
);
